import Header from "../components/Header";
import avatar from "@/assets/img/logo.jpg";
import { useSelector } from "react-redux";
import { RootState } from "@/reducers";
import img1 from "@/assets/img/capdocuatoi/img1.png";
import dacquyen from "@/assets/img/capdocuatoi/dacquyen.png";
import cachnangcap from "@/assets/img/capdocuatoi/cachnangcap.png";
import img2 from "@/assets/img/capdocuatoi/img2.png";
import { useTranslation } from "react-i18next";
const CapDoCuaToi = () => {
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  const { user } = useSelector((state: RootState) => state.authentication);
  return (
    <div className="wrapper">
      <div className="container-web capdocuatoi bgnew">
        <div className="header-capdocuatoi">
          <Header title={t("Cấp độ của tôi")} />

          <div className="text-center mt-3">
            <img
              width={60}
              height={60}
              className="rounded-circle"
              src={user?.avatar || avatar}
            />
            <p className="mt-4">{user?.username}</p>
          </div>
        </div>

        <main className="pb-5">
          <div className="p-3">
            <div className="text-center">{t("Cấp độ tiếp theo")}</div>

            <div className="d-flex align-items-center mt-4">
              <div
                className="w-100 d-flex flex-column align-items-center gap-2"
                style={{ fontSize: 12 }}
              >
                <div
                  style={{
                    border: "6px solid rgb(76, 68, 53)",
                    borderRadius: "50%",
                    width: 100,
                    height: 100,
                    fontSize: 11,
                  }}
                  className="d-flex flex-column align-items-center justify-content-center"
                >
                  <div>{t("Vẫn cần")}</div>
                  <div style={{ color: "#d5b377" }}>800M VND</div>
                </div>
                <div className="text-center">
                  <p className="mb-0">{t("Số tiền đầu tư")}</p>
                  <span>0 VND</span>
                </div>
              </div>

              <div
                className="w-100 d-flex flex-column align-items-center gap-2"
                style={{ fontSize: 12 }}
              >
                <div
                  style={{
                    border: "6px solid rgb(76, 68, 53)",
                    borderRadius: "50%",
                    width: 100,
                    height: 100,
                    fontSize: 11,
                  }}
                  className="d-flex flex-column align-items-center justify-content-center"
                >
                  <div>{t("Vẫn cần")}</div>
                  <div style={{ color: "#d5b377" }}>800M VND</div>
                </div>
                <div className="text-center">
                  <p className="mb-0">{t("Số tiền nạp")}</p>
                  <span>0 VND</span>
                </div>
              </div>
            </div>

            <div
              className="d-flex mt-4 py-4 rounded-2 position-relative"
              style={{ border: "1px solid rgb(113 96 67)" }}
            >
              <div
                className="position-absolute"
                style={{
                  top: -13,
                  left: 0,
                  height: 16,
                  right: 0,
                  width: "100%",
                  textAlign: "center",
                }}
              >
                <img
                  className="h-100 px-3"
                  src={dacquyen}
                  style={{ backgroundColor: "rgb(27 23 21)" }}
                />
              </div>
              <div className="w-100 text-center">
                <img style={{ maxWidth: 62 }} src={img1} />
                <p className="m-0" style={{ fontSize: 12, color: "#d5b377" }}>
                  {t("Số tiền chuyển thẻ 0%")}
                </p>
              </div>

              <div className="w-100 text-center">
                <img style={{ maxWidth: 62 }} src={img1} />
                <p className="m-0" style={{ fontSize: 12, color: "#d5b377" }}>
                  {t("Hoàn tiền đầu tư")}
                </p>
              </div>
            </div>

            <div
              className="mt-4 py-4 rounded-2 position-relative text-center"
              style={{ border: "1px solid rgb(113 96 67)" }}
            >
              <div
                className="position-absolute"
                style={{
                  top: -13,
                  left: 0,
                  height: 16,
                  right: 0,
                  width: "100%",
                  textAlign: "center",
                }}
              >
                <img
                  className="h-100 px-3"
                  src={cachnangcap}
                  style={{ backgroundColor: "rgb(27 23 21)" }}
                />
              </div>
              <img style={{ maxWidth: 218 }} src={img2} />
              <p
                className="mb-0 mt-1"
                style={{ fontSize: 12, color: "#d5b377" }}
              >
                {t("Khi số tiền đầu tư và số tiền nạp đạt mức tương ứng, bạn có thể được thăng cấp")}
              </p>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CapDoCuaToi;
